export enum GameStates {
    INTRO,
    EVENT,
    SKILLCHECK,
    GAME_OVER,
    RIP,
    LOG,
    BAG,
    ITEM_PICKER,
    MAP
}
